import styled       from 'styled-components';

import {
  BODY_TEXT_COLOR,
  ERROR_COLOR,
  NEGATIVE_COLOR,
  THIRD_COLOR,
}                   from '../../config/colors';

export const CONTAINER_HEIGHT = '100%';

export const styles = {
  closeIconWrap: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    cursor: 'pointer',
  },
  floatingText: { color: NEGATIVE_COLOR },
  textField: {
    width: '100%', fontSize: '16px', fontWeight: '400', color: BODY_TEXT_COLOR,
  },
  underlineStyle: { borderColor: '#e6e6e6' },
  closeIcon: { height: '35px', width: '35px', color: THIRD_COLOR },
  labelStyle: { },
  errorFormStyle: {
    width: '100%',
    height: '180px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
};

const FormWrapperDiv = styled.div`
    display: flex;
    color: ${BODY_TEXT_COLOR};
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0;
    height: 100%;
    font-family: 'Futura-Bold', 'Futura-Bold';
`;

const HeaderTitle = styled.div`
  text-align: center;
  margin-top: 18px;
  font-size: 21px;
  font-weight: 800;
  font-family: 'Futura-Bold';
  color: ${BODY_TEXT_COLOR};
`;

const Title = styled.div`
  text-align: center;
  margin-top: 18px;
  font-size: 18px;
  font-weight: 800;
  font-family: 'Futura-Bold';
  color: ${BODY_TEXT_COLOR};
`;


const HorLine = styled.hr`
    display: block;
    height: 2px;
    border: 0;
    border-top: 2px solid #f4f4f4;
    margin: 1em 0 0;
    padding: 0;
`;

const ButtonsWrapperDiv = styled.div`
  height: 50px;
  width: 100%;
  border-top: 1px solid #E6E6E7;
`;

const LeftDiv = styled.div`
    float:left; 
    width: 50%;
    background-color: #fff;
    height: 100%;
    border-right: 1px solid #E6E6E7;
    box-sizing: border-box;
`;

const RightDiv = styled.div`
    float: right;
    background-color: #fff;
    height: 100%;
    width: 50%;
`;

const ErrorDiv = styled.div`
  color: ${ERROR_COLOR}
`;

const ButtonDiv = styled.div`
    font-family: 'Roboto';
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding: 15px;
    color: ${(props) => {
    if (props.disabled) {
      return '#E6E6E7';
    } if (props.color) {
      return props.color;
    }
    return '#616161';
  }};
`;

export {
  FormWrapperDiv,
  HeaderTitle,
  Title,
  ErrorDiv,
  ButtonDiv,
  LeftDiv,
  RightDiv,
  ButtonsWrapperDiv,
  HorLine,
};



// WEBPACK FOOTER //
// ./src/components/EmailUpdateFormModal/styles.js